import React, { ComponentType } from "react";

export function lazyWithRetry<T extends ComponentType<any>>(
  componentImport: () => Promise<{ default: T }>,
  retries = 3,
  interval = 1000
): React.LazyExoticComponent<T> {
  return React.lazy(async () => {
    for (let i = 0; i < retries; i++) {
      try {
        return await componentImport();
      } catch (error) {
        const isLastAttempt = i === retries - 1;

        if (isLastAttempt) {
          const isChunkError =
            error instanceof Error &&
            (error.name === "ChunkLoadError" ||
              error.message.includes("Loading chunk") ||
              error.message.includes("Failed to fetch"));

          if (isChunkError) {
            console.warn("Chunk load failed after retries, reloading...");
            window.location.reload();

            return { default: (() => null) as unknown as T };
          }

          throw error;
        }

        await new Promise((resolve) => setTimeout(resolve, interval));
      }
    }

    throw new Error("Failed to load component");
  });
}
